import React from 'react';
import { IStandings } from '@/models/standings';
import Image from 'next/image';
import Link from 'next/link';
import { Label } from './text';
import { Table, TableBody, TableCell, TableRow } from './table';

interface TeamStandingsProps {
	standings: IStandings[];
	currentTeamSlug: string;
}

const TeamStandings: React.FC<TeamStandingsProps> = ({ standings, currentTeamSlug }) => {
	const currentTeamIndex = standings.findIndex((team) => team.contestantClubName === currentTeamSlug);

	if (currentTeamIndex === -1) return null;

	// Calculate start and end
	let startIndex = Math.max(0, currentTeamIndex - 2);
	let endIndex = Math.min(standings.length - 1, currentTeamIndex + 2);

	// Ensure always show 5 teams if possible
	if (endIndex - startIndex + 1 < 5 && standings.length >= 5) {
		if (startIndex === 0) {
			// If at the top, show more teams below
			endIndex = Math.min(standings.length - 1, 4);
		} else if (endIndex === standings.length - 1) {
			// If at the bottom, show more teams above
			startIndex = Math.max(0, standings.length - 5);
		}
	}

	const teamsToShow = standings.slice(startIndex, endIndex + 1);

	return (
		<div className="bg-black-500">
			<div className="px-6 py-8 text-center">
				<Label className="text-white font-bold">Stand</Label>
			</div>
			<div className="overflow-x-auto">
				<Table className="rounds-table table-auto overflow-x-scroll w-full text-white font-mono font-normal text-base text-center">
					<TableBody>
						{teamsToShow.map((team) => (
							<TableRow
								key={team.contestantId}
								className={` ${
									team.contestantClubName === currentTeamSlug
										? '!p-4 border-y border-[#3C384B]'
										: 'match-row !p-4 border-y border-red-500 !text-white -my-px'
								}`}
								striped={false}
							>
								<TableCell className="font-bold !text-right">{team.rank}</TableCell>
								<TableCell className="text-left">
									<Link href={`/teams/${team.contestantClubSlug}`}>
										<div className="flex items-center">
											{team.contestantLogo && (
												<div className="mr-2 flex-shrink-0">
													<Image
														src={team.contestantLogo}
														alt={team.contestantName}
														width={24}
														height={24}
														className="w-6 h-6 object-contain"
													/>
												</div>
											)}
											<span className="font-bold">{team.contestantName}</span>
										</div>
									</Link>
								</TableCell>

								<TableCell className="text-center font-bold">{team.points}</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</div>
		</div>
	);
};

export default TeamStandings;
